import type { localeValue } from '@/api/types';

export function localeValueEqual(a: localeValue, b: localeValue): boolean {
  return a.no === b.no && a.en === b.en;
}
